import "core-js/modules/es6.function.name";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import { TokenType as tt } from "../parser/tokenizer/types";
import isIdentifier from "../util/isIdentifier";
import Transformer from "./Transformer";

var TypeScriptTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inherits(TypeScriptTransformer, _Transformer);

  function TypeScriptTransformer(rootTransformer, tokens, isImportsTransformEnabled) {
    var _this;

    _classCallCheck(this, TypeScriptTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TypeScriptTransformer).call(this));
    _this.rootTransformer = rootTransformer;
    _this.tokens = tokens;
    _this.isImportsTransformEnabled = isImportsTransformEnabled;
    ;
    return _this;
  }

  _createClass(TypeScriptTransformer, [{
    key: "process",
    value: function process() {
      if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) {
        return true;
      }

      if (this.tokens.matches1(tt._public) || this.tokens.matches1(tt._protected) || this.tokens.matches1(tt._private) || this.tokens.matches1(tt._abstract) || this.tokens.matches1(tt._readonly) || this.tokens.matches1(tt.nonNullAssertion)) {
        this.tokens.removeInitialToken();
        return true;
      }

      if (this.tokens.matches1(tt._enum) || this.tokens.matches2(tt._const, tt._enum)) {
        this.processEnum();
        return true;
      }

      if (this.tokens.matches2(tt._export, tt._enum) || this.tokens.matches3(tt._export, tt._const, tt._enum)) {
        this.processEnum(true);
        return true;
      }

      return false;
    }
  }, {
    key: "processEnum",
    value: function processEnum() {
      var isExport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // We might have "export const enum", so just remove all relevant tokens.
      this.tokens.removeInitialToken();

      while (this.tokens.matches1(tt._const) || this.tokens.matches1(tt._enum)) {
        this.tokens.removeToken();
      }

      var enumName = this.tokens.identifierName();
      this.tokens.removeToken();

      if (isExport && !this.isImportsTransformEnabled) {
        this.tokens.appendCode("export ");
      }

      this.tokens.appendCode("var ".concat(enumName, "; (function (").concat(enumName, ")"));
      this.tokens.copyExpectedToken(tt.braceL);
      this.processEnumBody(enumName);
      this.tokens.copyExpectedToken(tt.braceR);

      if (isExport && this.isImportsTransformEnabled) {
        this.tokens.appendCode(")(".concat(enumName, " || (exports.").concat(enumName, " = ").concat(enumName, " = {}));"));
      } else {
        this.tokens.appendCode(")(".concat(enumName, " || (").concat(enumName, " = {}));"));
      }
    }
    /**
     * Rather than try to compute the actual enum values at compile time, we just create variables for
     * each one and let everything evaluate at runtime. There's some additional complexity due to
     * handling string literal names, including ones that happen to be valid identifiers.
     */

  }, {
    key: "processEnumBody",
    value: function processEnumBody(enumName) {
      var isPreviousValidIdentifier = false;
      var lastValueReference = null;

      while (true) {
        if (this.tokens.matches1(tt.braceR)) {
          break;
        }

        var nameToken = this.tokens.currentToken();
        var name = void 0;
        var nameStringCode = void 0;

        if (nameToken.type === tt.name) {
          name = this.tokens.identifierNameForToken(nameToken);
          nameStringCode = "\"".concat(name, "\"");
        } else if (nameToken.type === tt.string) {
          name = this.tokens.stringValueForToken(nameToken);
          nameStringCode = this.tokens.code.slice(nameToken.start, nameToken.end);
        } else {
          throw new Error("Expected name or string at beginning of enum element.");
        }

        var isValidIdentifier = isIdentifier(name);
        this.tokens.removeInitialToken();
        var valueIsString = void 0;
        var valueCode = void 0;

        if (this.tokens.matches1(tt.eq)) {
          var rhsEndIndex = this.tokens.currentToken().rhsEndIndex;

          if (rhsEndIndex == null) {
            throw new Error("Expected rhsEndIndex on enum assign.");
          }

          this.tokens.removeToken();

          if (this.tokens.matches2(tt.string, tt.comma) || this.tokens.matches2(tt.string, tt.braceR)) {
            valueIsString = true;
          }

          var startToken = this.tokens.currentToken();

          while (this.tokens.currentIndex() < rhsEndIndex) {
            this.tokens.removeToken();
          }

          valueCode = this.tokens.code.slice(startToken.start, this.tokens.tokenAtRelativeIndex(-1).end);
        } else {
          valueIsString = false;

          if (lastValueReference != null) {
            if (isPreviousValidIdentifier) {
              valueCode = "".concat(lastValueReference, " + 1");
            } else {
              valueCode = "(".concat(lastValueReference, ") + 1");
            }
          } else {
            valueCode = "0";
          }
        }

        if (this.tokens.matches1(tt.comma)) {
          this.tokens.removeToken();
        }

        var valueReference = void 0;

        if (isValidIdentifier) {
          this.tokens.appendCode("const ".concat(name, " = ").concat(valueCode, "; "));
          valueReference = name;
        } else {
          valueReference = valueCode;
        }

        if (valueIsString) {
          this.tokens.appendCode("".concat(enumName, "[").concat(nameStringCode, "] = ").concat(valueReference, ";"));
        } else {
          this.tokens.appendCode("".concat(enumName, "[").concat(enumName, "[").concat(nameStringCode, "] = ").concat(valueReference, "] = ").concat(nameStringCode, ";"));
        }

        lastValueReference = valueReference;
        isPreviousValidIdentifier = isValidIdentifier;
      }
    }
  }]);

  return TypeScriptTransformer;
}(Transformer);

export { TypeScriptTransformer as default };